import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const updateQuantityTurnPerBranch = async ({ params, token, callbacks }) => {
    const response = await connection({ method: 'POST', url: `${ENTITY_URL.SUCURSAL.UPDATE_QUANTITY_TURNS}`, extraHeaders: { token: token }, params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}
export default updateQuantityTurnPerBranch;